var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryChallanV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 14.1667V4.16667C15.832 3.72464 15.6564 3.30072 15.3439 2.98816C15.0313 2.67559 14.6074 2.5 14.1654 2.5H3.33203",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 17.5H16.668C17.11 17.5 17.5339 17.3244 17.8465 17.0118C18.159 16.6993 18.3346 16.2754 18.3346 15.8333V15C18.3346 14.779 18.2468 14.567 18.0906 14.4107C17.9343 14.2545 17.7223 14.1667 17.5013 14.1667H9.16797C8.94695 14.1667 8.73499 14.2545 8.57871 14.4107C8.42243 14.567 8.33464 14.779 8.33464 15V15.8333C8.33464 16.2754 8.15904 16.6993 7.84648 17.0118C7.53392 17.3244 7.11 17.5 6.66797 17.5ZM6.66797 17.5C6.22594 17.5 5.80202 17.3244 5.48946 17.0118C5.1769 16.6993 5.0013 16.2754 5.0013 15.8333V4.16667C5.0013 3.72464 4.82571 3.30072 4.51315 2.98816C4.20059 2.67559 3.77666 2.5 3.33464 2.5C2.89261 2.5 2.46868 2.67559 2.15612 2.98816C1.84356 3.30072 1.66797 3.72464 1.66797 4.16667V5.83333C1.66797 6.05435 1.75577 6.26631 1.91205 6.42259C2.06833 6.57887 2.28029 6.66667 2.5013 6.66667H5.0013",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13672 10.7185L9.80339 9.21851L8.13672 7.71851",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2148 10.7185L12.8815 9.21851L11.2148 7.71851",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryChallanV2);
export default __webpack_public_path__ + "static/media/deliveryChallanV2.abf0d56bd2fad3ad7fbb71e8c2795c18.svg";
export { ForwardRef as ReactComponent };